import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CompareSlider } from "@/components/CompareSlider";
import { PdfShowcase } from "@/components/PdfShowcase";
import { TOOLS } from "@/lib/tools";
import { useLang } from "@/i18n";

const EXAMPLES = [
  { slug: "ampliar", before: "upscale-before.png", after: "upscale-after.jpg", bg: "" },
  { slug: "vetorizar", before: "vector-before.png", after: "vector-after.svg", bg: "bg-white" },
  { slug: "remover-fundo", before: "bg-before.jpg", after: "bg-after.png", bg: "checkerboard" },
  { slug: "pdf-imagem" },
];

export const Examples = ({ base = "/examples" }) => {
  const { t, toolHref } = useLang();
  const [active, setActive] = useState(0);
  const ex = EXAMPLES[active];
  return (
    <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8" data-testid="examples-section">
      <p className="font-mono text-xs font-semibold uppercase tracking-wider text-slate-400">{t("examples.eyebrow")}</p>
      <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">{t("examples.title")}</h2>
      <p className="mt-3 max-w-2xl text-sm text-slate-600 md:text-base">{t("examples.sub")}</p>
      <div className="mt-10 grid gap-8 lg:grid-cols-12">
        <div className="grid gap-3 sm:grid-cols-2 lg:col-span-4 lg:grid-cols-1">
          {EXAMPLES.map((e, i) => {
            const tl = TOOLS[e.slug];
            const Icon = tl.icon;
            const on = i === active;
            return (
              <button key={e.slug} onClick={() => setActive(i)} data-testid={`example-tab-${e.slug}`}
                className={`flex w-full items-start gap-4 rounded-xl border p-5 text-left transition-colors ${on ? "border-slate-900 bg-white shadow-lg" : "border-slate-200 bg-white/60 hover:border-slate-400"}`}>
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg text-white" style={{ background: tl.color }}><Icon className="h-5 w-5" /></span>
                <span>
                  <span className="block font-semibold text-slate-900">{t(`tools.${e.slug}.name`)}</span>
                  <span className="mt-1 block text-xs leading-relaxed text-slate-500">{t(`examples.${e.slug}`)}</span>
                </span>
              </button>
            );
          })}
          <Link to={toolHref(ex.slug)} data-testid="example-try-link" className="inline-flex items-center pt-2 text-sm font-semibold text-slate-900 hover:underline">
            {t("examples.try")} <ArrowRight className="ml-1.5 h-4 w-4" />
          </Link>
        </div>
        <div className="lg:col-span-8">
          {ex.slug === "pdf-imagem" ? <PdfShowcase base={base} /> : (
            <div className={`mx-auto max-w-[620px] overflow-hidden rounded-2xl border border-slate-200 ${ex.bg}`}>
              <CompareSlider key={`${base}-${ex.slug}`} before={`${base}/${ex.before}`} after={`${base}/${ex.after}`}
                beforeLabel={t("examples.before")} afterLabel={t("examples.after")} className="bg-transparent" />
            </div>
          )}
          <p className="mt-3 text-center font-mono text-xs text-slate-400">{ex.slug === "pdf-imagem" ? t("examples.pdfCaption") : t("examples.drag")}</p>
        </div>
      </div>
    </section>
  );
};
